import clsx from 'clsx';

import {
  button,
  CREATE_BOOK_PATH,
  display,
  hand,
} from '@frontend/storefront/components/home/styles';
import Image from '@frontend/storefront/Image';
import Link from '@frontend/storefront/Link';

export function SplitPanel({
  heading,
  headingLevel = 'h2',
  text,
  quote,
  image,
  mediaPosition = 'right',
  priority = false,
}: {
  heading: string;
  headingLevel?: 'h1' | 'h2';
  text?: string;
  quote?: { text: string; author: string };
  image: { src: string; alt: string; width: number; height: number };
  mediaPosition?: 'left' | 'right';
  priority?: boolean;
}) {
  const Heading = headingLevel;
  const mediaLeft = mediaPosition === 'left';

  return (
    <section className="np-section">
      <div className="np-container">
        <div className="grid grid-cols-1 items-center gap-2 rounded-np-lg bg-np-cream p-4 desk:grid-cols-2 desk:gap-12 desk:p-[26px]">
          <div
            className={clsx(
              'flex max-w-[520px] flex-col items-start gap-6 px-2 pt-6 pb-4 desk:gap-8 desk:py-10',
              mediaLeft ? 'desk:px-0' : 'desk:pr-0 desk:pl-[39px]',
            )}
          >
            <Heading className={display}>{heading}</Heading>
            {text ? (
              <p className="text-lg leading-normal tab:text-xl">{text}</p>
            ) : null}
            {quote ? (
              <blockquote
                className={clsx(hand, 'max-w-[420px] text-xl tab:text-2xl')}
              >
                <p>&ldquo;{quote.text}&rdquo;</p>
                <p>&mdash; {quote.author}</p>
              </blockquote>
            ) : null}
            <Link href={CREATE_BOOK_PATH} className={button}>
              Create your book
            </Link>
          </div>
          <div className={clsx('-order-1', !mediaLeft && 'desk:order-none')}>
            <Image
              {...image}
              preload={priority}
              sizes="(min-width: 990px) 50vw, 100vw"
              className={clsx(
                'aspect-[640/537] h-full w-full object-cover',
                mediaLeft ? 'rounded-none' : 'rounded-np-lg',
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
